__turbopack_context__.v({
  "img": "Logo-module-scss-module__TFL-FG__img",
  "link": "Logo-module-scss-module__TFL-FG__link",
});
